import { render, staticRenderFns } from "./WelcomeText.vue?vue&type=template&id=462ea22f&scoped=true&"
import script from "./WelcomeText.vue?vue&type=script&lang=js&"
export * from "./WelcomeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ea22f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462ea22f')) {
      api.createRecord('462ea22f', component.options)
    } else {
      api.reload('462ea22f', component.options)
    }
    module.hot.accept("./WelcomeText.vue?vue&type=template&id=462ea22f&scoped=true&", function () {
      api.rerender('462ea22f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WelcomeText.vue"
export default component.exports